// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ==================== Layout General ==================== */
.panel-suscripcion-usuario[data-v-4238df87] {
  max-width: 1100px;
  margin: 0 auto;
}
.text-red[data-v-4238df87] {
  color: red;
}

/* ==================== BOTONES GLOBALES UNIFICADOS ==================== */
/* Centralizamos el color corporativo para no ensuciar el HTML */
[data-v-4238df87] .btn-primary {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
  color: #fff !important;
}
[data-v-4238df87] .btn-primary:hover,[data-v-4238df87] .btn-primary:focus,[data-v-4238df87] .btn-primary:active {
  background-color: #e66700 !important;
  border-color: #e66700 !important;
}
[data-v-4238df87] .border-primary {
  border-color: #ff7300 !important;
}

/* ==================== SWITCHES BOOTSTRAP-VUE (Formularios iniciales) ==================== */
[data-v-4238df87] 
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:checked
    ~ .custom-control-label::before
 {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
}
[data-v-4238df87] 
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:checked
    ~ .custom-control-label::after
 {
  background-color: #ffffff !important;
}
[data-v-4238df87] 
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:focus
    ~ .custom-control-label::before
 {
  box-shadow: 0 0 0 0.2rem rgba(255, 115, 0, 0.25) !important;
}
[data-v-4238df87] 
  .panel-suscripcion-usuario
    .custom-switch
    .custom-control-input:not(:checked)
    ~ .custom-control-label::before
 {
  background-color: #adb5bd !important;
  border-color: #adb5bd !important;
}
[data-v-4238df87] .panel-suscripcion-usuario .custom-switch .custom-control-label::before {
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

/* ==================== TOGGLE NATIVO (Estilo Administrador) ==================== */
.toggle-container[data-v-4238df87] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.toggle-button[data-v-4238df87]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ==================== ESTILOS DE TABLA (Unificados con el Admin) ==================== */
.cabecera-agrupada th[data-v-4238df87] {
  padding-top: 15px;
  padding-bottom: 5px;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.cabecera-agrupada th.bg-light[data-v-4238df87],
.cabecera-agrupada th.bg-channels[data-v-4238df87] {
  border-bottom: 2px solid #adb5bd !important;
}
.cabecera-secundaria th[data-v-4238df87] {
  border-top: none !important;
}
.espacio-separacion[data-v-4238df87] {
  padding-left: 30px !important;
}
.separador-vertical[data-v-4238df87] {
  border-left: 2px solid #ccc !important;
}
.bg-channels[data-v-4238df87] {
  background-color: #f8f9fa;
}
.text-center[data-v-4238df87] {
  text-align: center;
}
.tabla-subcriptores[data-v-4238df87] {
  table-layout: fixed;
  width: 100%;
}
.tabla-subcriptores td[data-v-4238df87] {
  vertical-align: middle;
  padding: 10px 8px;
}

/* ==================== RESPONSIVO ("No More Tables") ==================== */
@media only screen and (max-width: 992px) {
.tabla-subcriptores[data-v-4238df87],
  .tabla-subcriptores thead[data-v-4238df87],
  .tabla-subcriptores tbody[data-v-4238df87],
  .tabla-subcriptores th[data-v-4238df87],
  .tabla-subcriptores td[data-v-4238df87],
  .tabla-subcriptores tr[data-v-4238df87] {
    display: block;
    width: 100% !important;
}
.tabla-subcriptores thead tr[data-v-4238df87] {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.tabla-subcriptores tr[data-v-4238df87] {
    border: 1px solid #ccc;
    margin-bottom: 15px;
    background: #fff;
}
.tabla-subcriptores td[data-v-4238df87] {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 45% !important;
    white-space: normal;
    text-align: left;
    min-height: 45px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.tabla-subcriptores td[data-v-4238df87]:before {
    position: absolute;
    top: 50%;
    left: 15px;
    width: 40%;
    padding-right: 10px;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
    transform: translateY(-50%);
    content: attr(data-title);
}
.espacio-separacion[data-v-4238df87] {
    padding-left: 45% !important;
}
.separador-vertical[data-v-4238df87] {
    border-left: none !important;
}
.tabla-subcriptores colgroup[data-v-4238df87] {
    display: none;
}
.toggle-container[data-v-4238df87] {
    margin-left: 0 !important;
}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/PanelSuscripcionUsuario.vue"],"names":[],"mappings":";AAw5BA,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,cAAc;AAChB;AAEA;EACE,UAAU;AACZ;;AAEA,0EAA0E;AAC1E,gEAAgE;AAChE;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AAEA;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;AAEA;EACE,gCAAgC;AAClC;;AAEA,6FAA6F;AAC7F;;;;;;EAME,oCAAoC;EACpC,gCAAgC;AAClC;AAEA;;;;;;EAME,oCAAoC;AACtC;AAEA;;;;;;EAME,2DAA2D;AAC7D;AAEA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;AAClC;AAEA;EACE;;;wBAGsB;AACxB;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yFAAyF;AACzF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;AAEA;;EAEE,2CAA2C;AAC7C;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;AACE;;;;;;IAME,cAAc;IACd,sBAAsB;AACxB;AAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACf;AAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AAClB;AAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC7B;AAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;AAC3B;AAEA;IACE,4BAA4B;AAC9B;AAEA;IACE,4BAA4B;AAC9B;AAEA;IACE,aAAa;AACf;AAEA;IACE,yBAAyB;AAC3B;AACF","sourcesContent":["\n/* ==================== Layout General ==================== */\n.panel-suscripcion-usuario {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.text-red {\n  color: red;\n}\n\n/* ==================== BOTONES GLOBALES UNIFICADOS ==================== */\n/* Centralizamos el color corporativo para no ensuciar el HTML */\n:deep(.btn-primary) {\n  background-color: #ff7300 !important;\n  border-color: #ff7300 !important;\n  color: #fff !important;\n}\n\n:deep(.btn-primary:hover),\n:deep(.btn-primary:focus),\n:deep(.btn-primary:active) {\n  background-color: #e66700 !important;\n  border-color: #e66700 !important;\n}\n\n:deep(.border-primary) {\n  border-color: #ff7300 !important;\n}\n\n/* ==================== SWITCHES BOOTSTRAP-VUE (Formularios iniciales) ==================== */\n:deep(\n  .panel-suscripcion-usuario\n    .custom-switch\n    .custom-control-input:checked\n    ~ .custom-control-label::before\n) {\n  background-color: #ff7300 !important;\n  border-color: #ff7300 !important;\n}\n\n:deep(\n  .panel-suscripcion-usuario\n    .custom-switch\n    .custom-control-input:checked\n    ~ .custom-control-label::after\n) {\n  background-color: #ffffff !important;\n}\n\n:deep(\n  .panel-suscripcion-usuario\n    .custom-switch\n    .custom-control-input:focus\n    ~ .custom-control-label::before\n) {\n  box-shadow: 0 0 0 0.2rem rgba(255, 115, 0, 0.25) !important;\n}\n\n:deep(\n  .panel-suscripcion-usuario\n    .custom-switch\n    .custom-control-input:not(:checked)\n    ~ .custom-control-label::before\n) {\n  background-color: #adb5bd !important;\n  border-color: #adb5bd !important;\n}\n\n:deep(.panel-suscripcion-usuario .custom-switch .custom-control-label::before) {\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n/* ==================== TOGGLE NATIVO (Estilo Administrador) ==================== */\n.toggle-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.toggle-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ==================== ESTILOS DE TABLA (Unificados con el Admin) ==================== */\n.cabecera-agrupada th {\n  padding-top: 15px;\n  padding-bottom: 5px;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.cabecera-agrupada th.bg-light,\n.cabecera-agrupada th.bg-channels {\n  border-bottom: 2px solid #adb5bd !important;\n}\n\n.cabecera-secundaria th {\n  border-top: none !important;\n}\n\n.espacio-separacion {\n  padding-left: 30px !important;\n}\n\n.separador-vertical {\n  border-left: 2px solid #ccc !important;\n}\n\n.bg-channels {\n  background-color: #f8f9fa;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.tabla-subcriptores {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.tabla-subcriptores td {\n  vertical-align: middle;\n  padding: 10px 8px;\n}\n\n/* ==================== RESPONSIVO (\"No More Tables\") ==================== */\n@media only screen and (max-width: 992px) {\n  .tabla-subcriptores,\n  .tabla-subcriptores thead,\n  .tabla-subcriptores tbody,\n  .tabla-subcriptores th,\n  .tabla-subcriptores td,\n  .tabla-subcriptores tr {\n    display: block;\n    width: 100% !important;\n  }\n\n  .tabla-subcriptores thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .tabla-subcriptores tr {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    background: #fff;\n  }\n\n  .tabla-subcriptores td {\n    border: none;\n    border-bottom: 1px solid #eee;\n    position: relative;\n    padding-left: 45% !important;\n    white-space: normal;\n    text-align: left;\n    min-height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  .tabla-subcriptores td:before {\n    position: absolute;\n    top: 50%;\n    left: 15px;\n    width: 40%;\n    padding-right: 10px;\n    white-space: nowrap;\n    text-align: left;\n    font-weight: bold;\n    transform: translateY(-50%);\n    content: attr(data-title);\n  }\n\n  .espacio-separacion {\n    padding-left: 45% !important;\n  }\n\n  .separador-vertical {\n    border-left: none !important;\n  }\n\n  .tabla-subcriptores colgroup {\n    display: none;\n  }\n\n  .toggle-container {\n    margin-left: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
